import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'activityLetter',
})
export class ActivityLetterPipe implements PipeTransform {
    transform(value: unknown, ...args: unknown[]): unknown {
        let letter = '';
        if (typeof value === 'string' && !value.includes('project')) {
            letter = value.charAt(0).toUpperCase();
        }

        if (value === 'frezen_asfalteren') {
            letter = 'FA';
        }

        if (value === 'boorputten') {
            letter = 'BP';
        }

        return letter;
    }
}
